<template>
  <section class="underwriting-refer">
    <div class="table">
      <div class="tr">
        <span>Occupancy</span>
        <span>{{ getAllOptionName29('prop_insured', quoteForm.prop_insured) }}</span>
      </div>
      <div class="tr">
        <span>Type of Building</span>
        <span>{{ getAllOptionName29('bldg_types', quoteForm.bldg_typ) }}</span>
      </div>
      <div class="tr">
        <span>Gross Floor Area</span>
        <span>{{  quoteForm.floor_area }}</span>
      </div>
      <div class="tr">
        <span>Sum Insured of Building Structure</span>
        <span>{{  quoteForm.bsc_sum_insured | formatMoney(2, true) }}</span>
      </div>
      <!--      <div class="tr">-->
      <!--        <span>Coverage</span>-->
      <!--        <span>{{ getAllOptionName29('coverage', quoteForm.coverage_id) }}</span>-->
      <!--      </div>-->
      <div class="tr">
        <span>Property Age</span>
        <span>{{ getAllOptionName29('prop_age', quoteForm.prop_age) }}</span>
      </div>
      <!-- <div class="tr">
        <span>Owner's Liability</span>
        <span>{{ getOptionName('yesNoOptions', quoteForm.owner_liability_ind) }}</span>
      </div>
      <div class="tr">
        <span>Sum Insured of Owner's Liability</span>
        <span>{{ getAllOptionName26('owner_liability', quoteForm.sum_owner_liability) }}</span>
      </div> -->
    </div>

    <template v-if="benefitsList && benefitsList.length > 0">
      <h3>More Benefits</h3>
      <div class="benefits-list">
        <p
          v-for="(item, index) in benefitsList"
          :key="index">
          {{ item }}
        </p>
      </div>
    </template>
  </section>
</template>
<script>
import {mapState} from 'vuex'
import MixinOptions from '@/mixins/options'
import MixinFormat from '@/mixins/format'

export default {
  name: 'UnderwritingRefer',
  mixins: [MixinOptions,MixinFormat],
  computed: {
    ...mapState('quote', ['quoteForm']),
    localAllOptions() {
      return this.allOptions29
    },
    benefitsList() {
      const { benefits = [] } = this.quoteForm
      if(!benefits) {
        return []
      }
      return benefits.reduce((result, item) => {
        result.push(
          this.getAllOptionName26('benefits', item)
        )
        return result
      }, [])
    }
  }
}
</script>